(function () {
    'use strict';

    angular
        .module('salesflare.components.closingPercentagePerRep', [])
        .component('sfClosingPercentagePerRep', {
            templateUrl: 'app-ajs/components/dashboards/predefinedReports/closingPercentagePerRep/closingPercentagePerRep.html',
            controller,
            controllerAs: 'vm',
            bindings: {
                data: '<'
            }
        });

    function controller($translate) {

        const vm = this;

        vm.getUserName = function (user, index) {

            if (index === 0 && (user.name === 'Team average' || user.firstname === 'Team average')) {
                return $translate.instant('Team average');
            }

            return user.firstname || user.name;
        };

        vm.$onChanges = function (changes) {

            if (!changes || !changes.data || !changes.data.currentValue) {
                return;
            }

            // Translate "Team average" for the first user if present
            if (vm.data && vm.data.users && vm.data.users.length > 0) {
                const firstUser = vm.data.users[0];
                if (firstUser.name === 'Team average' || firstUser.firstname === 'Team average') {
                    firstUser.translatedName = $translate.instant('Team average');
                }
            }
        };
    }
})();
